import { Col, Row } from "antd";
import { FileUploadItem } from "./constants";
import FileUploadComponent, { FileData } from "../../../components/FileUploadComponent";
import { useCDNFileContext } from "../../../context/CDNFileContext/CDNFileContext";


const CDNFileDetail = () => {
	const { cdnFileDetail, setCDNFileData } = useCDNFileContext();

	const handleFileChange = (fileData: FileData[] | null) => {
		setCDNFileData(prevState => ({
			...prevState,
			image: fileData?.[0]?.file || null
		}));
	};

	return (
		<>				
			<Row gutter={20}>
				<Col span={20}>
					<FileUploadComponent
						title={FileUploadItem.label}
						onChange={(fileData: FileData[] | null) => handleFileChange(fileData)}
						maxFileSize={FileUploadItem.maxFileSize}
						allowedExtensions={FileUploadItem.extensions}
						defaultUrl={cdnFileDetail?.imageUrl}
					/>
				</Col>
			</Row>
		</>
	);
};

export default CDNFileDetail;
